import React from "react";
import "./App.css";
import { AppRoute } from "./AppRoute";
import { OrgContextProvider } from "./Context/orgContext";
import { ClientDetailsProvider } from "./Context/ClientDetails";

function App() {
  return (
    <ClientDetailsProvider>
      <OrgContextProvider>
        <AppRoute />
      </OrgContextProvider>
    </ClientDetailsProvider>
  );
}

export default App;
